import { WEB_DESKTOP_RALALI_URL } from 'common/constants'

export const searchPulsa = {
  query: [
    'pulsa',
    'voucher',
    'billing',
    'indosat',
    'telkomsel',
    'axis',
    'xl',
    'smartfren',
  ],
  title: 'Pulsa',
  link: `${WEB_DESKTOP_RALALI_URL}/billing/pulsa`,
}
export const searchPln = {
  query: ['pln', 'listrik', 'token', 'tagihan', 'billing'],
  title: 'PLN',
  link: `${WEB_DESKTOP_RALALI_URL}/billing/listrik`,
}
export const searchPdam = {
  query: [
    'air',
    'pdam',
    'pam',
    'tagihan',
    'palyja',
    'aetra',
    'billing',
  ],
  title: 'PDAM',
  link: `${WEB_DESKTOP_RALALI_URL}/billing/pdam`,
}
export const searchBpjs = {
  query: [
    'asuransi',
    'kesehatan',
    'bpjs',
    'jaminan',
    'sehat',
    'health',
    'insurance',
    'billing',
  ],
  title: 'BPJS',
  link: `${WEB_DESKTOP_RALALI_URL}/billing/bpjs`,
}
export const searchPdata = {
  query: [
    'data',
    'internet',
    'paket',
    'indosat',
    'telkomsel',
    'axis',
    'xl',
    'smartfren',
    'kuota',
    'billing',
  ],
  title: 'Paket Data',
  link: `${WEB_DESKTOP_RALALI_URL}/billing/paket-data`,
}
export const searchGiftcard = {
  query: ['giftcard', 'gift', 'card', 'wallet', 'billing', 'saldo'],
  title: 'Giftcard',
  link: `${WEB_DESKTOP_RALALI_URL}/billing/gift-card`,
}
